import React from 'react';
import { createSvgIcon } from '../../utils/createSvgIcon';

export const TransactionPurchase = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="2 2 21 20" fill="none">
    <g fill="currentColor">
      <path d="M18.291 15.5L10.3687 15.5C10.2722 15.668 10.1733 15.841 10.0724 16.0181L9.2035 15.5231C9.30528 15.3444 9.40515 15.1698 9.50267 15C9.55126 14.9154 9.59927 14.832 9.64664 14.75L9.79098 14.5H11.4291C10.8993 13.5664 10.2519 12.4052 9.60626 11.2471L9.60424 11.2435C8.83576 9.86503 8.06979 8.49114 7.50175 7.5H5.6665L5.6665 6.5H8.07965L8.22399 6.75C8.8066 7.75911 9.64248 9.25844 10.4756 10.7528L10.4777 10.7565C10.711 11.175 10.944 11.593 11.1714 12H16.3436L18.0757 9H10.6324V8H18.9417L19.3747 8.75L16.921 13H11.7312C12.0414 13.5527 12.33 14.0635 12.5802 14.5L18.291 14.5V15.5Z" />
      <path d="M9.79102 18.0002H8.79102L8.29102 17.1342L8.79102 16.2681H9.79102L10.291 17.1342L9.79102 18.0002Z" />
      <path d="M17.791 18.2321H16.791L16.291 17.366L16.791 16.5H17.791L18.291 17.366L17.791 18.2321Z" />
    </g>
  </svg>,
  'TransactionPurchase'
);
